export default {
      id: "common__reefer_gt-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__reefer_gt",
      toString: function () {
        return this.url;
      }
    }